/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { PrimaryButton } from "../../components";
import { useNavigate } from "react-router";
import { useDropLocations } from "../../store/useDropLocations";
import { useEffect } from "react";
import { DropLocationsTable } from "./DropLocationsTable";
import { useAuth } from "../../store/useAuth";

function DropLocationsScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const { getDropLocations, dropLocations, getLocationStats } =
    useDropLocations();
  const { user } = useAuth();
  // Creating a location is Super Admin only (the backend enforces the same).
  const canCreateLocations = Number(user?.user_role) === 7;

  useEffect(() => {
    getDropLocations();
    getLocationStats();
  }, []);

  /** Functions */
  const addDropLocation = () => navigate("/add-drop-locations");
  return (
    <div>
      <div className="flex w-full justify-between mb-2">
        <h1 className="font-satoshi text-2xl font-bold text-dark">
          Drop locations
        </h1>
        <div className="flex flex-row items-center gap-4">
          {canCreateLocations ? (
            <PrimaryButton
              onClick={addDropLocation}
              label="Add new"
              className="h-10"
            />
          ) : null}
        </div>
      </div>
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!dropLocations?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no drop location created yet.
          </p>
        ) : (
          <DropLocationsTable />
        )}
      </div>
    </div>
  );
}

export default withProtectedRoute(DropLocationsScreen);
